"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DynaNodeAddress = /** @class */ (function () {
    function DynaNodeAddress(dynaNodeAddress) {
        var _this = this;
        this.connectionId = '';
        this.server = {};
        this.isValid = function () {
            return _this.connectionId !== undefined &&
                ['n', 's', 'i'].some(function (item) { return item === _this.server.secureLevel; }) &&
                !!_this.server.ipAddress &&
                (_this._getServerPort() === ''
                    || _this.server.port === 0
                    || (_this.server.port !== undefined && _this.server.port !== undefined && _this.server.port > 0));
        };
        if (dynaNodeAddress)
            this.address = dynaNodeAddress;
    }
    Object.defineProperty(DynaNodeAddress.prototype, "address", {
        get: function () {
            if (this.isValid())
                return "" + (this.connectionId || '') + (this.connectionId && '@' || '') + this.serverAddress;
            else
                return '';
        },
        set: function (dynaNodeAddress) {
            if (!dynaNodeAddress)
                this._clear();
            if (!this._parse(dynaNodeAddress)) {
                this._clear();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeAddress.prototype, "serverAddress", {
        get: function () {
            return this.server.secureLevel + "/" + this.server.ipAddress + this._getServerPort('/');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeAddress.prototype, "wsServerAddress", {
        get: function () {
            return "ws" + (this.server.secureLevel === 's' ? 's' : '') + "://" + this.server.ipAddress + this._getServerPort(':');
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeAddress.prototype._getServerPort = function (prefix) {
        if (prefix === void 0) { prefix = ''; }
        if (this.server.port !== undefined) {
            return "" + prefix + String(this.server.port);
        }
        return '';
    };
    DynaNodeAddress.prototype._clear = function () {
        this.connectionId = '';
        this.server = {};
        this.server.secureLevel = undefined;
        this.server.ipAddress = undefined;
        this.server.port = undefined;
        return this;
    };
    DynaNodeAddress.prototype._parse = function (dynaNodeAddress) {
        this._clear();
        if (!dynaNodeAddress)
            return true;
        if (dynaNodeAddress.indexOf('@') === -1)
            dynaNodeAddress = '@' + dynaNodeAddress;
        var splitter = dynaNodeAddress.lastIndexOf('@');
        var serverParts = dynaNodeAddress.substr(splitter + 1).split('/');
        this.connectionId = dynaNodeAddress.substr(0, splitter);
        this.server.secureLevel = serverParts[0].toLowerCase();
        this.server.ipAddress = serverParts[1];
        this.server.port = serverParts[2] ? Number(serverParts[2]) : undefined;
        return this.isValid();
    };
    return DynaNodeAddress;
}());
exports.DynaNodeAddress = DynaNodeAddress;
//# sourceMappingURL=DynaNodeAddress.js.map